module.exports = __webpack_public_path__ + "img/Master-6.6875ec6f.gif";